// @flow
import {
  call,
  takeEvery,
  put,
  select,
  race,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { normalize } from 'normalizr';
import * as types from '../types/reports';
import * as selectors from '../reducers';
import { REQUEST_TIMEOUT } from '../settings';
import { throwTimeout } from '../lib/http';
import * as reportActions from '../actions/reports';
import { Reports } from '../api';

function* fetchReport(action) {
  const token = yield select(selectors.getToken);
  const { key, date_range, selectedElement } = action.payload;
  const profiles = yield select(selectors.getProfiles);
  const school = profiles.filter(profile => profile.type == 'admin')[0].school;

  try {
    // Fetch the next route
    const { reportsResponse, timeout } = yield race({
      reportsResponse: call(
        [Reports.custom, key],
        {
          token,
          filters: {
            begin_date: date_range.startDate.format('YYYY-MM-DD').toString(),
            end_date: date_range.endDate.format('YYYY-MM-DD').toString(),
            selected_element: selectedElement.id,
            school,
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchReport saga');
    }

    yield put(reportActions.fetchReportSucceed(reportsResponse));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(reportActions.fetchReportFaied({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: -1,
    }));
  }
}

export function* watchFetchReports(): Iterator<any> {
  yield takeEvery(
    types.START_FETCHING_REPORT,
    fetchReport,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/reports.js